<template>
  <simple-header-desktop v-if="!isMobile() && isShowHeader"  id="header" />
</template>

<script>
import { mapState } from "vuex";

import NavigateMixings from "@/mixins/NavigateMixings";
import PlatformsMixins from "@/mixins/PlatformsMixins";

import SimpleHeaderDesktop from "./SimpleHeaderDesktop.vue";

export default {
  name: "SimpleHeader",
  mixins: [NavigateMixings, PlatformsMixins],
  data: () => ({
    subMenuOpened: false,
  }),
  computed: {
    ...mapState({
      isNotFoundPage: (state) => state.global.isNotFoundPage,
      isHideHeader: (state) => state.global.isHideHeader,
    }),
    isShowHeader() {
      return !(this.isNotFoundPage || this.isHideHeader);
    },
  },
  components: { SimpleHeaderDesktop },
};
</script>

<style lang="scss" scoped></style>
